<template>
  <div class="m-b-50">
    <p class="font-weight-bold text-capitalize">
      {{ item.title }}
    </p>
    <p
      v-for="(p,i) in item.context"
      :key="i"
    >
      {{ p }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'VacancyDetailsItems',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped>

</style>
